/***
 *
 *   USER AVATAR STYLES
 *   Ported from ui-reference/src/components/ui/avatar.tsx.
 *
 **********/

const Style = {
    base: 'relative inline-flex shrink-0 overflow-hidden rounded-full',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    image: 'aspect-square h-full w-full object-cover',
    fallback:
        'flex h-full w-full items-center justify-center rounded-full bg-primary-100 text-xs font-semibold text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',
    bordered: 'border border-border',
};

export default Style;
